/**
 * Creates a temporaryStorage storage with the necessary methods.
 */
const createStorage = () => {
  let temporaryStorage = {};
  return {
    /**
      * Get a value from SessionStorage, if exists, by key
      * @param {String} k key
      * @returns {Object|undefined} value
      */
    get(k) {
      const value = temporaryStorage[k];
      if (value === undefined) {
        return undefined;
      }
      return JSON.parse(value);
    },

    /**
      * Set a value to SessionStorage by key
      * @param {String} k key
      * @param {Object} value value
      */
    set(k, value) {
      temporaryStorage[k] = JSON.stringify(value);
    },

    /**
      * Delete a SessionStorage value by key
      * @param {String} k key
      */
    del(k) {
      delete temporaryStorage[k];
    },

    /**
      * Delete everything in the sessionStorage
      */
    clear() {
      temporaryStorage = {};
    },
  };
};

export const sessionStorage = createStorage();
sessionStorage.create = createStorage;
